import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import moment from "moment";
import { Col, Input, Row, List, Card, Spin, Modal, notification as Notification, Select } from 'antd';
import { SearchOutlined, ExclamationCircleOutlined, CarOutlined, SortAscendingOutlined } from '@ant-design/icons';
import { errorMessageNotification, isMobile } from "../../../../helpers";

const { confirm } = Modal;

const type = "trip";
let searchTimeout = null;

class TripList extends Component {

    constructor(props) {
        super(props);
        this.endpoint = { keyOne: "trips" };
        this.state = {
            isResponsive: false,
            dataActives: [],
            dataArchives: [],
            totalActives: 0,
            totalArchives: 0,
            loadings: {
                data: false
            },
            hasMore: true
        };
        this.filter = {
            page: 1,
            pagesize: 90,
            query: "",
            sortdirection: "desc"
        }
    }

    componentWillMount() {
        if (isMobile()) {
            this.setState({
                isResponsive: true,
            });
        }

        this.getData();

    }

    getData = (isScroll) => {

        let { loadings } = this.state;

        if (loadings.data) {
            return;
        }

        if (!isScroll) {
            loadings.data = true;
        }

        this.setState({ loadings });

        this.props.dispatch(actions.definitions.getData({
            ...this.endpoint,
            filter: this.filter
        })).then(response => {
            loadings.data = false;

            // response.actives.data.push({
            //     title: 'Yeni Talep Oluştur',
            //     address: "Adana, Türkey",
            //     isNew: true,
            //     name: "   ",
            //     id: -1,
            // });

            let newDataActives = [];
            newDataActives.push({
                title: 'Yeni Talep Oluştur',
                address: "Adana, Türkey",
                isNew: true,
                name: "   ",
                id: -1,
            });

            response.actives.data.forEach(item => {
                newDataActives.push(item)
            });

            // let sortedData = response.actives.data.sort((a, b) => (a.id > b.id ? 1 : -1));

            this.setState({
                dataActives: newDataActives,
                totalActives: response.actives.total,
                dataArchives: response.archives.data,
                totalArchives: response.archives.total,
                loadings
            });


        })
            .catch(error => {

                loadings.data = false;

                this.setState({
                    loadings
                });

                // Notification.error({
                //     message: i18n.t(`error`, {
                //         lng: this.props.currentLanguage,
                //     }),
                //     description: errorMessageNotification(error),
                //     className: "general-notification",
                //     placement: "bottomLeft",
                //     duration: 100,
                // });

            })
    }

    onChangeSearchbox = (e) => {

        this.filter.query = e.target.value;

        if (e.target.value.length > 2) {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                this.getData(true);
            }, 500);
        } else {
            this.getData(true);
        }


    }

    onChangeSort = (value) => {
        this.filter.sortdirection = value;
        this.getData(true);
    }

    onDeleteConfirm = (id) => {

        let _this = this;
        let endpoint = { keyOne: `${type}`, idOne: id };

        confirm({
            centered: true,
            title: 'Adres Silme',
            icon: <ExclamationCircleOutlined />,
            content: 'Bu işlem bir daha geri alınamaz.',
            okText: "Sil",
            okType: "danger",
            onOk() {
                _this.props
                    .dispatch(
                        actions.definitions["deleteData"]({
                            ...endpoint,
                        })
                    )
                    .then((response) => {
                        _this.getData()
                        Notification.success({
                            message: errorMessageNotification(response),
                            className: "general-notification",
                            placement: "bottomLeft",
                            duration: 3,
                        });
                    }

                    );
            },
            onCancel() {
            },
        });

    }

    render() {

        let { loadings, dataActives, dataArchives, totalActives, totalArchives } = this.state;

        return (

            <Fragment>

                {
                    loadings.data &&
                    <div className="ant-loading loading-content">
                        <Spin
                            tip={`${i18n.t(`loading`, {
                                lng: this.props.currentLanguage,
                            })}`}
                        />
                    </div>
                }

                {
                    !loadings.data &&
                    <div className='list-container trips'>
                        <div className='page-header'>
                            <Row>
                                <Col xs={16} sm={16} md={16} lg={16} xl={16}>
                                    <h1>
                                        <span className='count'>{totalActives}</span>
                                        <span className='label'>Aktif Talebiniz Bulunmakta</span>
                                    </h1>
                                </Col>
                                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div className='searchbox'>
                                        <Input placeholder='Arama...'
                                            width={200}
                                            prefix={<SearchOutlined />}
                                            onChange={(e) => this.onChangeSearchbox(e)}
                                        ></Input>
                                    </div>
                                </Col>
                                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div className='searchbox'>
                                        <Select
                                            defaultValue="desc"
                                            options={[
                                                { value: 'desc', label: 'En yeniden, en eskiye', icon: <SortAscendingOutlined /> },
                                                { value: 'asc', label: 'En eskiden, en yeniye' },
                                            ]}
                                            onSelect={(e) => this.onChangeSort(e)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>

                        <List
                            className='content-list'
                            grid={{
                                gutter: 16,
                                xs: 3,
                                sm: 3,
                                md: 3,
                                lg: 3,
                                xl: 3,
                                xxl: 3,
                            }}
                            dataSource={dataActives}
                            renderItem={(item) => (

                                <List.Item
                                >
                                    {
                                        item.isNew ?

                                            <Card
                                                hoverable
                                                title={item.title}
                                                className='new-item-trip'
                                                onClick={() => this.props.history.push(`/app/trips/create`)}
                                            >
                                                <div><CarOutlined /></div>

                                            </Card>
                                            :
                                            <div className='item-detail'
                                                onClick={() => this.props.history.push(`/app/trips/${item.id}`)}
                                            >

                                                <p className='date'>
                                                    {moment(item.departureDate).format('DD MMMM YYYY')}

                                                </p>
                                                <p className='day'>
                                                    {moment(item.departureDate).format('dddd')}

                                                </p>
                                                <p className='date'>
                                                    {moment(item.departureDate).format('LT')}
                                                </p>
                                                <p className='subject mt-20'>
                                                    Durumu
                                                </p>
                                                <p className='description'>
                                                    {item.statusText}
                                                </p>
                                                <p className='subject'>
                                                    {item.startPoint.shortAddress}
                                                </p>
                                                <p className='description' style={{ minHeight: 32 }}>
                                                    {item.startPoint.address}                                                </p>
                                                <p className='subject'>
                                                    {item.endPoint.shortAddress}
                                                </p>
                                                <p className='description' style={{ minHeight: 32 }}>
                                                    {item.endPoint.address}
                                                </p>
                                                <p className='subject'>
                                                    Talep No
                                                </p>
                                                <p className='description'>
                                                    #{item.id}
                                                </p>

                                            </div>

                                    }
                                </List.Item>
                            )}
                        />

                    </div>
                }
                {
                    !loadings.data &&
                    <div
                        className='list-container trips'
                    >
                        <div className='page-header'>
                            <Row>
                                <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                                    <h1>
                                        <span className='count-black'>{totalArchives}</span>
                                        <span className='label'>Talebiniz Arşivlenmekte</span>
                                    </h1>
                                </Col>
                            </Row>
                        </div>

                        <List
                            className='content-list'
                            grid={{
                                gutter: 16,
                                xs: 3,
                                sm: 3,
                                md: 3,
                                lg: 3,
                                xl: 3,
                                xxl: 3,
                            }}
                            dataSource={dataArchives}
                            renderItem={(item) => (

                                <List.Item
                                >
                                    {
                                        item.isNew ?

                                            <Card
                                                hoverable
                                                title={item.title}
                                                className='new-item-trip'
                                                onClick={() => this.props.history.push(`/app/trips/create`)}
                                            >
                                                <div><CarOutlined /></div>

                                            </Card>
                                            :
                                            <div className='item-detail item-detail-black'
                                                onClick={() => this.props.history.push(`/app/trips/${item.id}`)}

                                            >

                                                <p className='date'>
                                                    {moment(item.departureDate).format('DD MMMM YYYY')}

                                                </p>
                                                <p className='day'>
                                                    {moment(item.departureDate).format('dddd')}

                                                </p>
                                                <p className='date'>
                                                    {moment(item.departureDate).format('LT')}
                                                </p>
                                                <p className='subject mt-20'>
                                                    Durumu
                                                </p>
                                                <p className='description'>
                                                    {item.statusText}
                                                </p>
                                                <p className='subject'>
                                                    {item.startPoint.shortAddress}
                                                </p>
                                                <p className='description' style={{ minHeight: 32 }}>
                                                    {item.startPoint.address}                                                </p>
                                                <p className='subject'>
                                                    {item.endPoint.shortAddress}
                                                </p>
                                                <p className='description' style={{ minHeight: 32 }}>
                                                    {item.endPoint.address}
                                                </p>
                                                <p className='subject'>
                                                    Talep No
                                                </p>
                                                <p className='description'>
                                                    #{item.id}
                                                </p>

                                            </div>

                                    }
                                </List.Item>
                            )}
                        />
                    </div>
                }
            </Fragment>

        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripList);


// WEBPACK FOOTER //
// ./src/components/App/Views/Trip/TripList.js